import './FormFilterInput.scss';
import * as React from "react";
import { IFormFilter } from '../../../../reducers/index';

export interface IFormFilterInputProps {
    formFilter: IFormFilter;
    hideActiveToggle?: boolean;
    activeLabel?: string;
    onFilter?: (formFilter: IFormFilter) => void;
}

class FormFilterInput extends React.PureComponent<IFormFilterInputProps, any> {

    render() {
        const {
            formFilter,
            onFilter,
            hideActiveToggle,
            activeLabel
        } = this.props;

        const showLabel = activeLabel && activeLabel != "" ? "Show " + activeLabel : "Show Inactive"
        const hideLabel = activeLabel && activeLabel != "" ? "Hide " + activeLabel : "Hide Inactive"

        return (
            <>
                <input 
                    id="filter.search"
                    name="filter" 
                    type="text" 
                    placeholder="Filter..." 
                    className="form-control py-1 px-2 mr-2 resize" 
                    style={{ width: "150px" }} 
                    value={formFilter.search}
                    onChange={e => {
                        let filter = { ...formFilter };
                        filter.search = e.target.value;
                        onFilter(filter);
                    }}
                />
                {!hideActiveToggle && (
                    <button
                        onClick={
                            () => {
                                let filter = { ...formFilter };
                                filter.showInActive = !filter.showInActive;
                                onFilter(filter);
                            }
                        }
                        type="button"
                        className="btn btn-outline-dark mr-2"
                        style={{ minWidth: '125px' }}
                    >
                        {formFilter.showInActive ? hideLabel : showLabel}
                    </button>
                )}
            </>
        )
    }
}

export default FormFilterInput;